// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_webpack@5.102.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/dropdown-arrow-12x24.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * We cannot easily remove these global variables, because they're used in multiple places.
 *
 * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)
 */
:root {
  --button-size-m: 32px;
  --button-size-s: 24px;
  --button-size-xs: 20px;
}
@media (pointer: coarse) {
  :root {
    --button-size-m: 44px;
    --button-size-s: 32px;
    --button-size-xs: 24px;
  }
}
.button {
  --button-bg: var(--gray-01);
  --button-bg-active: var(--primary-color);
  --button-bg-disabled: var(--button-bg);
  --button-bg-hover: var(--gray-02);
  --button-color: var(--gray-08);
  --button-color-active: var(--white-09);
  --button-color-disabled: var(--disabled-color);

  align-items: center;
  appearance: none;
  background-color: var(--button-bg);
  border: none;
  color: var(--button-color);
  display: inline-flex;
  flex-shrink: 0;
  font-family: var(--default-font-family);
  font-size: var(--default-font-size);
  font-weight: var(--bold-font-weight);
  justify-content: center;
  outline: none;
  text-align: center;
  text-decoration: none;
  transition:
    background-color var(--default-transition),
    box-shadow var(--default-transition),
    color var(--default-transition);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  width: fit-content; /* Do not stretch in column flex layouts */
}
.button::-moz-focus-inner {
    border: 0;
  }
.button:is(:disabled,[aria-disabled="true"]) {
    background-color: var(--button-bg-disabled);
    color: var(--button-color-disabled);
  }
.button:not(:disabled,[aria-disabled="true"]) {
    cursor: pointer;
  }
.button:not(:disabled,[aria-disabled="true"]):hover {
      background-color: var(--button-bg-hover);
    }
.button:focus {
    border-radius: var(--is-not-keynav, 1px);
    box-shadow: var(--is-not-keynav, var(--default-outline));
    outline: var(--is-not-keynav, var(--default-native-outline));
  }
:is(.button:active,.button.active,.button[aria-pressed='true'],.button[aria-expanded='true']):not(:disabled) {
      background-color: var(--button-bg-active);
      color: var(--button-color-active);
    }
.button:where(:not(.button-icon,.button-round)) > .d-icon:first-child {
    margin-right: 2px;
  }
.button .button--label {
    cursor: inherit;
  }
.button .button--label + .d-icon {
    margin-left: 4px;
  }
.light-bg .button {
  --button-bg: var(--white-09);
}
.dark-bg .button {
  --button-bg: var(--white-01);
  --button-bg-active: var(--white-09);
  --button-bg-hover: var(--white-02);
  --button-color: var(--white-08);
  --button-color-active: var(--primary-color);
}
/*********
 * Sizes *
 *********/
/* Default Size (M) */
.button {
  --button-size: var(--button-size-m);
  --button-icon-size: 24px;
  --button-padding: 12px;

  height: var(--button-size);
  line-height: var(--button-size);
  min-width: calc(var(--button-size)*2);
  padding: 0 var(--button-padding);
}
.button > .d-icon,.button > .d-icon-stack,.button > .d-icon-stack > .d-icon {
    height: var(--button-icon-size);
    width: var(--button-icon-size);
  }
.button-s {
  --button-size: var(--button-size-s);
  --button-icon-size: 20px;
  --button-padding: 8px;
}
.button-xs {
  --button-size: var(--button-size-xs);
  --button-touch-size: calc(100% - var(--button-size) + var(--button-size-s));
  --button-icon-size: 16px;
  --button-padding: 4px;

  font-size: var(--small-font-size);
  position: relative;

  /* increase the size of the button's touch target without increasing the visual size */
}
.button-xs::before {
    content: '';
    display: block;
    height: var(--button-touch-size);
    position: absolute;
    width: var(--button-touch-size);
  }
@media (pointer: coarse) {
.button-xs {
    --button-icon-size: 20px;
}
  }
/* Not an official button size */
.button-xxs {
  --button-size: 16px;
  --button-icon-size: 12px;
  --button-padding: 2px;
}
/***************
 * Icon Button *
 ***************/
.button-icon {
  --button-padding: 4px;

  min-width: 0;
  width: var(--button-size);
}
.button-icon.button-s {
    --button-padding: 0;
  }
.button-icon.button-xs {
    --button-padding: 1px;
  }
.button-icon.button-xxs {
    --button-padding: 2px;
  }
/************************
 * Button with dropdown *
 ************************/
.button-with-dropdown {
  --dropdown-arrow-width: 12px;
  --dropdown-arrow-color: currentColor;
}
.button-with-dropdown::after {
    background-color: var(--dropdown-arrow-color);
    content: '';
    display: inline-block;
    height: 24px;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: var(--dropdown-arrow-width);
  }
:not(.button-icon):is(.button-with-dropdown::after) {
      margin-left: 4px;
    }
.button-icon.button-with-dropdown {
  width: calc(var(--button-size) + var(--dropdown-arrow-width)); /* Adds space for the dropdown */
}
/************
 * Variants *
 ************/
/* Primary */
.button.button-primary {
  --button-bg: var(--primary-color);
  --button-bg-active: var(--primary-color-darken-30);
  --button-bg-disabled: var(--gray-03);
  --button-bg-hover: var(--primary-color-darken-15);
  --button-color: var(--white-09);
  --button-color-active: var(--white-09);
  --button-color-disabled: var(--white-07);
}
.light-bg .button-primary {
  --button-color: var(--gray-01-opaque);
  --button-color-disabled: var(--gray-01-opaque);
}
.dark-bg .button-primary {
  --button-bg: var(--white-08);
  --button-bg-active: var(--white-09);
  --button-bg-disabled: var(--white-03);
  --button-bg-hover: var(--white-09);
  --button-color: var(--gray-08-opaque);
  --button-color-active: var(--primary-color);
  --button-color-disabled: var(--white-04);
}
/* Borderless */
.button.button-borderless {
  --button-bg: transparent;
  --button-bg-active: var(--gray-02);
  --button-bg-hover: var(--gray-01);
  --button-color: var(--gray-06);
  --button-color-active: var(--primary-color);

  min-width: var(--button-size);
}
.button.button-borderless:not(.button-icon) {
    --button-padding: 2px;
  }
.button-borderless.button-with-dropdown:not(:disabled) {
  --dropdown-arrow-color: #6d7177;
}
.button-borderless.button-error {
    --button-color: var(--color-error);
    --button-color-active: var(--color-error-dark);
  }
.button-borderless.button-warning {
    --button-color: var(--color-warning-darker);
    --button-color-active: var(--color-warning-dark);
  }
.button-borderless.button-info {
    --button-color: var(--color-info-dark);
    --button-color-active: var(--color-info-light);
  }
.button-borderless.button-success {
    --button-color: var(--color-success);
    --button-color-active: var(--color-success-dark);
  }
.dark-bg .button-borderless {
  --button-bg-active: var(--white-02);
  --button-bg-hover: var(--white-01);
  --button-color: var(--white-06);
  --button-color-active: var(--white-09);
}
.button-error:is(.dark-bg .button-borderless) {
    --button-color: var(--color-error-lighter);
    --button-color-active: var(--color-error-light);
  }
.button-warning:is(.dark-bg .button-borderless) {
    --button-color: var(--color-warning);
    --button-color-active: var(--color-warning-light);
  }
.button-success:is(.dark-bg .button-borderless) {
    --button-color: var(--color-success);
    --button-color-active: var(--color-success-light);
  }
/* Link */
.button.button-link {
  --button-bg: transparent;
  --button-bg-active: var(--gray-02);
  --button-bg-hover: var(--gray-01);
  --button-color: var(--link-color);
  --button-color-active: var(--link-color);
  --button-padding: 2px;

  min-width: var(--button-size);
}
.dark-bg .button-link {
  --button-bg-active: var(--white-02);
  --button-bg-hover: var(--white-01);
  --button-color: var(--link-color-light);
  --button-color-active: var(--white-09);
}
/* Round */
.button.button-round {
  --button-size: 48px;
  --button-bg: var(--white-09);
  --button-bg-active: var(--gray-02-opaque);
  --button-bg-hover: var(--gray-01-opaque);
  --button-color: var(--primary-color);
  --button-color-active: var(--primary-color);
  --button-color-hover: var(--primary-color);

  border-radius: 50%;
  box-shadow: var(--default-box-shadow);
  min-width: 0;
  width: var(--button-size);
}
.button.button-round.button-s {
    --button-size: 36px;
  }
/* Rough draft, not ready for implementation */
.dark-bg .button-round {
  --button-bg: var(--gray-08);
  --button-bg-active: var(--gray-06-opaque);
  --button-bg-hover: var(--gray-07-opaque);

  /* --primary-color-light (now #85b5f0) is not defined yet */
  --button-color: #85b5f0;
  --button-color-active: #85b5f0;
  --button-color-hover: #85b5f0;
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/button/button-variables.css","webpack://./packages/ui/src/button/button.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;ACfA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,sCAAsC;EACtC,iCAAiC;EACjC,8BAA8B;EAC9B,sCAAsC;EACtC,8CAA8C;;EAE9C,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,cAAc;EACd,uCAAuC;EACvC,mCAAmC;EACnC,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB;;;mCAGiC;EACjC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB,EAAE,0CAA0C;AA8ChE;AA5CE;IACE,SAAS;EACX;AAEA;IACE,2CAA2C;IAC3C,mCAAmC;EACrC;AAEA;IACE,eAAe;EAKjB;AAHE;MACE,wCAAwC;IAC1C;AAGF;IACE,wCAAwC;IACxC,wDAAwD;IACxD,4DAA4D;EAC9D;AAME;MACE,yCAAyC;MACzC,iCAAiC;IACnC;AAGF;IACE,iBAAiB;EACnB;AAEA;IACE,eAAe;EACjB;AAEA;IACE,gBAAgB;EAClB;AAGF;EACE,4BAA4B;AAC9B;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,2CAA2C;AAC7C;AAEA;;UAEU;AAEV,qBAAqB;AAErB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;;EAEtB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAuC;EACvC,gCAAgC;AAQlC;AANE;IAGE,+BAA+B;IAC/B,8BAA8B;EAChC;AAGF;EACE,mCAAmC;EACnC,wBAAwB;EACxB,qBAAqB;AACvB;AAEA;EACE,oCAAoC;EACpC,2EAA2E;EAC3E,wBAAwB;EACxB,qBAAqB;;EAErB,iCAAiC;EACjC,kBAAkB;;EAElB,sFAAsF;AAYxF;AAXE;IACE,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;EACjC;AAEA;AAlBF;IAmBI,wBAAwB;AAE5B;EADE;AAGF,gCAAgC;AAChC;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;AAEA;;gBAEgB;AAEhB;EACE,qBAAqB;;EAErB,YAAY;EACZ,yBAAyB;AAa3B;AAXE;IACE,mBAAmB;EACrB;AAEA;IACE,qBAAqB;EACvB;AAEA;IACE,qBAAqB;EACvB;AAGF;;yBAEyB;AAEzB;EACE,4BAA4B;EAC5B,oCAAoC;AActC;AAZE;IACE,6CAA6C;IAC7C,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,mDAAgE;IAChE,kCAAkC;EAKpC;AAHE;MACE,gBAAgB;IAClB;AAIJ;EACE,6DAA6D,EAAE,gCAAgC;AACjG;AAEA;;aAEa;AAEb,YAAY;AAEZ;EACE,iCAAiC;EACjC,kDAAkD;EAClD,oCAAoC;EACpC,iDAAiD;EACjD,+BAA+B;EAC/B,sCAAsC;EACtC,wCAAwC;AAC1C;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,kCAAkC;EAClC,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;AAC1C;AAEA,eAAe;AAEf;EACE,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;;EAE3C,6BAA6B;AAK/B;AAHE;IACE,qBAAqB;EACvB;AAGF;EACE,+BAA+B;AACjC;AAGE;IACE,kCAAkC;IAClC,8CAA8C;EAChD;AAEA;IACE,2CAA2C;IAC3C,gDAAgD;EAClD;AAEA;IACE,sCAAsC;IACtC,8CAA8C;EAChD;AAEA;IACE,oCAAoC;IACpC,gDAAgD;EAClD;AAGF;EACE,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;AAgBxC;AAdE;IACE,0CAA0C;IAC1C,+CAA+C;EACjD;AAEA;IACE,oCAAoC;IACpC,iDAAiD;EACnD;AAEA;IACE,oCAAoC;IACpC,iDAAiD;EACnD;AAGF,SAAS;AAET;EACE,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,wCAAwC;EACxC,qBAAqB;;EAErB,6BAA6B;AAC/B;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,uCAAuC;EACvC,sCAAsC;AACxC;AAEA,UAAU;AAEV;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,wCAAwC;EACxC,oCAAoC;EACpC,2CAA2C;EAC3C,0CAA0C;;EAE1C,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,yBAAyB;AAK3B;AAHE;IACE,mBAAmB;EACrB;AAGF,8CAA8C;AAC9C;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,wCAAwC;;EAExC,2DAA2D;EAC3D,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;AAC/B","sourcesContent":["/*\n * We cannot easily remove these global variables, because they're used in multiple places.\n *\n * PLEASE DO NOT ADD MORE VARIABLES HERE! (Unless they're used in multiple places, too.)\n */\n:root {\n  --button-size-m: 32px;\n  --button-size-s: 24px;\n  --button-size-xs: 20px;\n}\n\n@media (--touch) {\n  :root {\n    --button-size-m: 44px;\n    --button-size-s: 32px;\n    --button-size-xs: 24px;\n  }\n}\n","@import './button-variables.css';\n\n.button {\n  --button-bg: var(--gray-01);\n  --button-bg-active: var(--primary-color);\n  --button-bg-disabled: var(--button-bg);\n  --button-bg-hover: var(--gray-02);\n  --button-color: var(--gray-08);\n  --button-color-active: var(--white-09);\n  --button-color-disabled: var(--disabled-color);\n\n  align-items: center;\n  appearance: none;\n  background-color: var(--button-bg);\n  border: none;\n  color: var(--button-color);\n  display: inline-flex;\n  flex-shrink: 0;\n  font-family: var(--default-font-family);\n  font-size: var(--default-font-size);\n  font-weight: var(--bold-font-weight);\n  justify-content: center;\n  outline: none;\n  text-align: center;\n  text-decoration: none;\n  transition:\n    background-color var(--default-transition),\n    box-shadow var(--default-transition),\n    color var(--default-transition);\n  user-select: none;\n  white-space: nowrap;\n  width: fit-content; /* Do not stretch in column flex layouts */\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  &:is(:disabled, [aria-disabled=\"true\"]) {\n    background-color: var(--button-bg-disabled);\n    color: var(--button-color-disabled);\n  }\n\n  &:not(:disabled, [aria-disabled=\"true\"]) {\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--button-bg-hover);\n    }\n  }\n\n  &:focus {\n    border-radius: var(--is-not-keynav, 1px);\n    box-shadow: var(--is-not-keynav, var(--default-outline));\n    outline: var(--is-not-keynav, var(--default-native-outline));\n  }\n\n  &:active,\n  &.active,\n  &[aria-pressed='true'],\n  &[aria-expanded='true'] {\n    &:not(:disabled) {\n      background-color: var(--button-bg-active);\n      color: var(--button-color-active);\n    }\n  }\n\n  &:where(:not(.button-icon, .button-round)) > .d-icon:first-child {\n    margin-right: 2px;\n  }\n\n  & .button--label {\n    cursor: inherit;\n  }\n\n  & .button--label + .d-icon {\n    margin-left: 4px;\n  }\n}\n\n.light-bg .button {\n  --button-bg: var(--white-09);\n}\n\n.dark-bg .button {\n  --button-bg: var(--white-01);\n  --button-bg-active: var(--white-09);\n  --button-bg-hover: var(--white-02);\n  --button-color: var(--white-08);\n  --button-color-active: var(--primary-color);\n}\n\n/*********\n * Sizes *\n *********/\n\n/* Default Size (M) */\n\n.button {\n  --button-size: var(--button-size-m);\n  --button-icon-size: 24px;\n  --button-padding: 12px;\n\n  height: var(--button-size);\n  line-height: var(--button-size);\n  min-width: calc(var(--button-size) * 2);\n  padding: 0 var(--button-padding);\n\n  & > .d-icon,\n  & > .d-icon-stack,\n  & > .d-icon-stack > .d-icon {\n    height: var(--button-icon-size);\n    width: var(--button-icon-size);\n  }\n}\n\n.button-s {\n  --button-size: var(--button-size-s);\n  --button-icon-size: 20px;\n  --button-padding: 8px;\n}\n\n.button-xs {\n  --button-size: var(--button-size-xs);\n  --button-touch-size: calc(100% - var(--button-size) + var(--button-size-s));\n  --button-icon-size: 16px;\n  --button-padding: 4px;\n\n  font-size: var(--small-font-size);\n  position: relative;\n\n  /* increase the size of the button's touch target without increasing the visual size */\n  &::before {\n    content: '';\n    display: block;\n    height: var(--button-touch-size);\n    position: absolute;\n    width: var(--button-touch-size);\n  }\n\n  @media (--touch) {\n    --button-icon-size: 20px;\n  }\n}\n\n/* Not an official button size */\n.button-xxs {\n  --button-size: 16px;\n  --button-icon-size: 12px;\n  --button-padding: 2px;\n}\n\n/***************\n * Icon Button *\n ***************/\n\n.button-icon {\n  --button-padding: 4px;\n\n  min-width: 0;\n  width: var(--button-size);\n\n  &.button-s {\n    --button-padding: 0;\n  }\n\n  &.button-xs {\n    --button-padding: 1px;\n  }\n\n  &.button-xxs {\n    --button-padding: 2px;\n  }\n}\n\n/************************\n * Button with dropdown *\n ************************/\n\n.button-with-dropdown {\n  --dropdown-arrow-width: 12px;\n  --dropdown-arrow-color: currentColor;\n\n  &::after {\n    background-color: var(--dropdown-arrow-color);\n    content: '';\n    display: inline-block;\n    height: 24px;\n    mask-image: url('~@disy/cadenza-icons/dropdown-arrow-12x24.svg');\n    width: var(--dropdown-arrow-width);\n\n    :not(.button-icon)& {\n      margin-left: 4px;\n    }\n  }\n}\n\n.button-icon.button-with-dropdown {\n  width: calc(var(--button-size) + var(--dropdown-arrow-width)); /* Adds space for the dropdown */\n}\n\n/************\n * Variants *\n ************/\n\n/* Primary */\n\n.button.button-primary {\n  --button-bg: var(--primary-color);\n  --button-bg-active: var(--primary-color-darken-30);\n  --button-bg-disabled: var(--gray-03);\n  --button-bg-hover: var(--primary-color-darken-15);\n  --button-color: var(--white-09);\n  --button-color-active: var(--white-09);\n  --button-color-disabled: var(--white-07);\n}\n\n.light-bg .button-primary {\n  --button-color: var(--gray-01-opaque);\n  --button-color-disabled: var(--gray-01-opaque);\n}\n\n.dark-bg .button-primary {\n  --button-bg: var(--white-08);\n  --button-bg-active: var(--white-09);\n  --button-bg-disabled: var(--white-03);\n  --button-bg-hover: var(--white-09);\n  --button-color: var(--gray-08-opaque);\n  --button-color-active: var(--primary-color);\n  --button-color-disabled: var(--white-04);\n}\n\n/* Borderless */\n\n.button.button-borderless {\n  --button-bg: transparent;\n  --button-bg-active: var(--gray-02);\n  --button-bg-hover: var(--gray-01);\n  --button-color: var(--gray-06);\n  --button-color-active: var(--primary-color);\n\n  min-width: var(--button-size);\n\n  &:not(.button-icon) {\n    --button-padding: 2px;\n  }\n}\n\n.button-borderless.button-with-dropdown:not(:disabled) {\n  --dropdown-arrow-color: #6d7177;\n}\n\n.button-borderless {\n  &.button-error {\n    --button-color: var(--color-error);\n    --button-color-active: var(--color-error-dark);\n  }\n\n  &.button-warning {\n    --button-color: var(--color-warning-darker);\n    --button-color-active: var(--color-warning-dark);\n  }\n\n  &.button-info {\n    --button-color: var(--color-info-dark);\n    --button-color-active: var(--color-info-light);\n  }\n\n  &.button-success {\n    --button-color: var(--color-success);\n    --button-color-active: var(--color-success-dark);\n  }\n}\n\n.dark-bg .button-borderless {\n  --button-bg-active: var(--white-02);\n  --button-bg-hover: var(--white-01);\n  --button-color: var(--white-06);\n  --button-color-active: var(--white-09);\n\n  &.button-error {\n    --button-color: var(--color-error-lighter);\n    --button-color-active: var(--color-error-light);\n  }\n\n  &.button-warning {\n    --button-color: var(--color-warning);\n    --button-color-active: var(--color-warning-light);\n  }\n\n  &.button-success {\n    --button-color: var(--color-success);\n    --button-color-active: var(--color-success-light);\n  }\n}\n\n/* Link */\n\n.button.button-link {\n  --button-bg: transparent;\n  --button-bg-active: var(--gray-02);\n  --button-bg-hover: var(--gray-01);\n  --button-color: var(--link-color);\n  --button-color-active: var(--link-color);\n  --button-padding: 2px;\n\n  min-width: var(--button-size);\n}\n\n.dark-bg .button-link {\n  --button-bg-active: var(--white-02);\n  --button-bg-hover: var(--white-01);\n  --button-color: var(--link-color-light);\n  --button-color-active: var(--white-09);\n}\n\n/* Round */\n\n.button.button-round {\n  --button-size: 48px;\n  --button-bg: var(--white-09);\n  --button-bg-active: var(--gray-02-opaque);\n  --button-bg-hover: var(--gray-01-opaque);\n  --button-color: var(--primary-color);\n  --button-color-active: var(--primary-color);\n  --button-color-hover: var(--primary-color);\n\n  border-radius: 50%;\n  box-shadow: var(--default-box-shadow);\n  min-width: 0;\n  width: var(--button-size);\n\n  &.button-s {\n    --button-size: 36px;\n  }\n}\n\n/* Rough draft, not ready for implementation */\n.dark-bg .button-round {\n  --button-bg: var(--gray-08);\n  --button-bg-active: var(--gray-06-opaque);\n  --button-bg-hover: var(--gray-07-opaque);\n\n  /* --primary-color-light (now #85b5f0) is not defined yet */\n  --button-color: #85b5f0;\n  --button-color-active: #85b5f0;\n  --button-color-hover: #85b5f0;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
